import React from "react";

const CopyrightNotice = () => {
  return (
    <div className="container mt-4">
      <h1 className="mb-4">Copyright Notice</h1>
      <p>© 2024 Kirtanavali. All rights reserved.</p>
      <p>
        The content and materials provided in this app, including but not
        limited to text, graphics, images, logos, and audio files, are the
        property of Kirtanavali and are protected by copyright law.
      </p>
      <p>
        Unauthorized reproduction or distribution of this material is prohibited
        and may result in legal action.
      </p>
      <p>
        For inquiries regarding the use of content from this app, please contact{" "}
        <a href="mailto:kirtanpriya@gmail.com">kirtanpriya@gmail.com</a>.
      </p>
    </div>
  );
};

export default CopyrightNotice;
